"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.createAction = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var debug = require("debug")("ReduxList:CreateAction");
/**
 * Call list.create method to add result to slice.items
 *
 * @param {String}   listName    Slice name - for error messages
 * @param {Function} dispatch    Redux dispatch
 * @param {Function} api         API method
 * @param {Function} onChange    Appy on items array before changing state
 *
 * @param {Object} data Model data
 * @param {Array}  rest Other paramaters passed when calling list.create
 *
 * @return {Promise<Object<error, result>>}
 */


var createAction = function createAction(_ref) {
  var listName = _ref.listName,
      dispatch = _ref.dispatch,
      api = _ref.api,
      hasDispatchStart = _ref.hasDispatchStart,
      hasDispatchEnd = _ref.hasDispatchEnd,
      onChange = _ref.onChange;
  return function (data) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    if (hasDispatchStart) {
      dispatch({
        type: "".concat(listName, "_CREATE_START"),
        payload: {
          listName: listName,
          items: (0, _isArray.default)(data) ? data : [data]
        }
      });
    }

    return _promise.default.resolve().then(function () {
      var _context;

      return api.apply(void 0, (0, _concat.default)(_context = [data]).call(_context, rest));
    }).then(function (result) {
      if (hasDispatchEnd) {
        dispatch({
          type: "".concat(listName, "_CREATE_END"),
          payload: {
            listName: listName,
            items: (0, _isArray.default)(result) ? result : [result],
            onChange: onChange
          }
        });
      }

      return {
        result: result
      };
    }).catch(function (error) {
      // reducer and promise resolve the same data
      error.date = new Date();
      dispatch({
        type: "".concat(listName, "_CREATE_ERROR"),
        payload: error
      });
      return {
        error: error
      };
    });
  };
};

exports.createAction = createAction;